module.exports = __webpack_public_path__ + "img/cup-grey.c43bbc4f.svg";